<template>
  <b-modal id="customer-send-enroll" class="customer-send-enroll" ref="modal" title="Enviar Recordatorio" hide-footer>
    <div class="row mb-2">
      <div class="col-sm-12 text-center">
        <strong>Recuerda:</strong> El coste de cada mensaje de recuperación de paciente son 0.2€ + IVA
      </div>
    </div>
    <div class="row">
      <div class="col-sm-9">
        <doctor-selector id="customer_enroll_doctor_id" v-model="doctor_id"></doctor-selector>
      </div>
      <div class="col-sm-3">
        <button type="button" class="btn btn-block btn-primary btn-wabident" :disabled="is_loading"
          @click="sendEnroll">Enviar</button>
      </div>
    </div>
  </b-modal>
</template>


<script>
export default {
  props: ['customer'],
  data() {
    return {
      doctor_id: null,
      is_loading: false,
    }
  },
  computed: {
    ...mapGetters(['errorwindow', 'msgwindow', 'clinic'])
  },
  methods: {
    show() {
      this.is_loading = false;
      this.doctor_id = this.customer.doctor_id ? this.customer.doctor_id : null;
      this.$refs.modal.show();
    },
    sendEnroll() {
      if (!this.doctor_id) {
        this.errorwindow.show('Error', 'Por favor, elige primero un Profesional para nombrar en el mensaje');
        return;
      }

      if (this.is_loading) {
        return;
      }
      this.is_loading = true;

      axios.post(`/twilio/enroll_customer`, {
        clinic_id: this.clinic.id,
        customer_id: this.customer.id,
        doctor_id: this.doctor_id,
      }).then((response) => {
        const data = response.data;
        if (data.error) {
          this.errorwindow.show('Error', data.error);
        } else {
          this.msgwindow.success('Recordatorio enviado con éxito. La confirmación del cliente llegará por correo');
          this.$refs.modal.hide();
        }
      }).catch((error) => {
        this.errorwindow.show('Error', 'Error enviando el Whatsapp. Consulta con el Administrador');
      }).then(() => {
        this.is_loading = false;
      });
    }
  }
}
</script>
